import { z } from "zod/v4";
import { clubSkillLevelSchema } from "../schemas/skill-level";
import { fetchApi, fetchVoid } from "./internal";

export const skillLevels = {
	list: (clubId: string) => fetchApi(`/clubs/${clubId}/levels`, z.array(clubSkillLevelSchema)),
	create: (clubId: string, data: { name: string; sort_order?: number }) =>
		fetchApi(`/clubs/${clubId}/levels`, clubSkillLevelSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
	update: (clubId: string, levelId: string, data: { name?: string; sort_order?: number }) =>
		fetchApi(`/clubs/${clubId}/levels/${levelId}`, clubSkillLevelSchema, {
			method: "PUT",
			body: JSON.stringify(data),
		}),
	delete: (clubId: string, levelId: string) =>
		fetchVoid(`/clubs/${clubId}/levels/${levelId}`, {
			method: "DELETE",
		}),
};
